import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "label", "disabled", "hideLabel", "error", "loading", "loadingAriaLabel", "required", "maxRows"];
import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { InlineError } from '../primitives/inline-error/inline-error.js';
import { useUniqueId } from '../utils/useUniqueId.js';
import { TextAreaAutosize } from './text-area-autosize/text-area-autosize.js';
import styles from './text-area.module.js';
import { useLabelable } from '../util-components/labelable/useLabelable.js';
var TextArea = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var _clsx2;

  var className = props.className,
      label = props.label,
      disabled = props.disabled,
      hideLabel = props.hideLabel,
      error = props.error,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      loadingAriaLabel = props.loadingAriaLabel,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      maxRows = props.maxRows,
      rest = _objectWithoutProperties(props, _excluded);

  var textAreaId = useUniqueId('text-area-');
  var inlineErrorId = useUniqueId('inline-error-');
  var hasError = !!error && !disabled;
  var ariaDescribedBy = clsx(rest['aria-describedby'], _defineProperty({}, inlineErrorId, hasError));
  var Label = useLabelable(label, textAreaId);
  return jsxs("div", {
    className: clsx([styles.textAreaContainer], (_clsx2 = {}, _defineProperty(_clsx2, styles.disabled, disabled), _defineProperty(_clsx2, styles.error, hasError), _clsx2), className),
    children: [jsx(Label, {
      className: clsx([styles.label], _defineProperty({}, styles.hidden, hideLabel)),
      hideLabel: hideLabel
    }), jsx(TextAreaAutosize, _objectSpread(_objectSpread({}, rest), {}, {
      ref: forwardedRef,
      "aria-describedby": ariaDescribedBy,
      "aria-invalid": hasError,
      "aria-required": required,
      disabled: disabled,
      hasError: hasError,
      id: textAreaId,
      loading: loading,
      loadingAriaLabel: loadingAriaLabel,
      maxRows: maxRows,
      required: required
    })), jsx(InlineError, {
      className: styles.inlineError,
      id: inlineErrorId,
      children: error
    })]
  });
});
export { TextArea };